import React, { useContext } from "react";
import { AppBar, Avatar, Toolbar, Typography } from "@mui/material";
import { SchoolContext } from "../../App";

import logo from "../../assets/media/logo.jpg";

function RootHeader() {
  const consumer = useContext(SchoolContext);
  return (
    <AppBar position="fixed" style={{ bgColor: "primary.main" }}>
      <Toolbar variant="dense">
        <div style={{ padding: "4px 8px" }}>
          <Avatar src={logo} style={{ width: 50, height: 50 }} />
        </div>
        <Typography variant="h6" color="inherit" component="div">
          {consumer.schoolName}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default RootHeader;
